import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-content">
          <div className="about-header">
            <h2>About Us</h2>
            <div className="company-description">
              <h3 className="company-tagline">Global Sansys is India's AI-first education company</h3>
              <p className="company-story">
                As one of India's pioneering AI education platforms, Global Sansys has been transforming student careers since our founding. By bridging the gap between academic learning and industry requirements, we make education more practical, relevant and career-focused.
              </p>
              <p className="company-story">
                Powered by cutting-edge AI curriculum and industry partnerships, we continuously provide comprehensive training programs that prepare college students for high-demand tech roles across India's growing AI ecosystem. Our world-class teams of industry practitioners and educators come from leading tech companies and premier institutions, but are bound by one simple purpose: making every student industry-ready.
              </p>
            </div>
          </div>

          <div className="about-stats">
            <div className="stat-item">
              <div className="stat-number">7,000+</div>
              <div className="stat-label">Students Trained</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">50+</div>
              <div className="stat-label">University Partners</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">95%</div>
              <div className="stat-label">Placement Success</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">100+</div>
              <div className="stat-label">Industry Projects</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;